// Import packages
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { history } from "../configs/history";

// Import assets
import '../assets/styles/layout.scss'

// Import components
import Header from "../components/Header";
import Footer from "../components/Footer";

// Import utils
import { getPropsFromState } from "../redux/mapStateToProps";
import {
    GetLanguages,
    GetStaticTexts,
    GetProject,
    GetAbout,
    GetMainSlider,
    GetContact,
    GetBuildings,
    GetCurrency,
    GetAreaBestOffers,
    FilterState,
    GetBadges,
    GetAreasInitialInfo,
    GetAboutSlider, GetAreasMinPrices
} from "../redux/actions";
import MetaTags from "../components/MetaTags";
// import LeftBlock from "../components/LeftBlock";
import {Call, FilterClose, Mobil_icon, SoundOfIcon, SoundOnIcon} from "../assets/images";
import CallModel from "../components/modal/callModel/CallModel";
import {BUILDING_TYPE, MAX_AREA, MAX_PRICE, MIN_AREA, MIN_PRICE} from "../constants/acceptedConsts";
import ComingSoon from "./comingSoon/ComingSoon";
import HomeFilterBlock from "../components/HomeFilterBlock";
// import HousesFilter from "./housesFilter/HousesFilter";

function Layout (props) {
    const filtersInitialValues = {
        buildingSlug: null,
        floors: undefined,
        roomsCount: [],
        minArea: MIN_AREA,
        maxArea: MAX_AREA,
        minPrice: MIN_PRICE,
        maxPrice: MAX_PRICE,
        types:BUILDING_TYPE.Apartments,
        statuses: [],
        sort: 'price',
    }
    const [filters, setFilters] = useState(filtersInitialValues)
    const [mobileMenuIsOpen, setMobileMenuIsOpen] = useState(false);
    const [soundOn, setSoundOn] = useState(false)
    const [callModelOpen,setCallModelOpen] = useState(false)

    useEffect(() => {
        props.GetLanguages()
        props.GetProject()
        props.GetStaticTexts()
        props.GetAreaBestOffers()
        props.GetBadges()
        props.GetMainSlider().then(() => {
            props.GetAbout()
            props.GetAboutSlider()
            props.GetContact()
            // props.GetBuildings()
        })
    }, [ props.selectedLanguage?.id]);


    useEffect(() => {
        props.GetAreasInitialInfo()
        props.GetAreasMinPrices()
        props.GetCurrency()
    }, []);


    const toggleMobileMenu = () => {
        setMobileMenuIsOpen(!mobileMenuIsOpen)
    };

    const toggleCallBtn = () => {
        setCallModelOpen(!callModelOpen)
    };

    const toggleSoundOn =(e)=> {
        let video = document.querySelector('video')
            e.preventDefault();
            video.muted = !video.muted;
            setSoundOn(!soundOn)
    }

    const { children ,staticTexts} = props;
    return process.env.REACT_APP_WEB_ENVIRONMENT === 'production'  ? <div className={`LayoutWrapper ${mobileMenuIsOpen ? "mobileMenuOpen" : ""}`}>
        <ComingSoon mobileMenuIsOpen={mobileMenuIsOpen}
                    toggleMobileMenu={toggleMobileMenu}/>
    </div> : <div className={`LayoutWrapper ${mobileMenuIsOpen ? "mobileMenuOpen" : ""}`}>
         {/*<MetaTags/>*/}
         <Header mobileMenuIsOpen={mobileMenuIsOpen}
                 toggleMobileMenu={toggleMobileMenu}/>
         {/*<CallModel  toggleCallBtn={toggleCallBtn}*/}
         {/*            callModelOpen={callModelOpen}/>*/}
         {/*{*/}
         {/*    window.innerWidth < 1001 ?*/}
         {/*        <div className={`menu-dropdown ${block ? "open" : ""}`}>*/}
         {/*            <span className={'close-icon'}  onClick={toggleMobileFilter}><FilterClose/></span>*/}
         {/*            <LeftBlock toggleMobileFilter={toggleMobileFilter}*/}
         {/*                       filtersInitialValues={filtersInitialValues}*/}
         {/*                       setFilters={setFilters}*/}
         {/*                       filters={filters} />*/}
         {/*        </div> :*/}
         {/*        <div className={'left-block-wrapper'}>*/}
         {/*            <LeftBlock  filtersInitialValues={filtersInitialValues}*/}
         {/*                        setFilters={setFilters}*/}
         {/*                        filters={filters}/>*/}
         {/*        </div>*/}
         {/*}*/}

         <div className={`MainContent`}>
             {children}
         </div>
         {/*<button className='callBtn' onClick={toggleCallBtn}>*/}
         {/*    <Call title=''/>*/}
         {/*</button>*/}
         <Footer/>

          {/*<div className={'layoutDisable'}>*/}
          {/*       <HomeFilterBlock  filtersInitialValues={filtersInitialValues}*/}
          {/*                      setFilters={setFilters}*/}
          {/*                      filtersList={filters}/>*/}
          {/*   </div>*/}
    </div>
}

const mapStateToProps = (state) => {
    return getPropsFromState(state, [
        'languages',
        'selectedLanguage',
        'staticTexts',
    ])
};

const mapDispatchToProps = {
    GetAreasInitialInfo,
    GetLanguages,
    GetStaticTexts,
    GetAbout,
    GetMainSlider,
    GetContact,
    GetBuildings,
    GetProject,
    GetCurrency,
    GetAreaBestOffers,
    FilterState,
    GetBadges,
    GetAboutSlider,
    GetAreasMinPrices,
};

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
